<video controls class="col-12 p-2">
    <source src="assets/Agora-Help-Video/{{videoPath}}" type="video/mp4">
    Your browser does not support the video tag.
</video>